import React from 'react';
import { Helmet } from 'react-helmet-async';
import { StatuteHero } from '../components/statute/StatuteHero';
import { TableOfContents } from '../components/statute/TableOfContents';
import { ChapterContent } from '../components/statute/ChapterContent';
import { StatuteContent } from '../components/statute/StatuteContent';
import { LegalEntityDetails } from '../components/common/LegalEntityDetails';

interface Chapter {
  title: string;
  content: React.ReactNode;
}

export function StatutePage() {
  const [activeChapter, setActiveChapter] = React.useState<number | null>(null);

  const chapters: Chapter[] = [
    {
      title: "Rozdział I - Postanowienia Ogólne",
      content: <>
        <div className="space-y-6 text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white">
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.1</h3>
            <p>„Fundacja Znajdki" w skrócie „ZNAJDKI", zwana dalej Fundacją, działa na podstawie Ustawy z dn. 6 kwietnia 1984 r. o fundacjach (Dz.U. z 1991 r. nr 46 poz. 203 – tekst jednolity) oraz ustawy z dnia 24 kwietnia 2003 r. o działalności pożytku publicznego i wolontariacie (Dz.U. Nr 96 poz. 873 z późniejszymi zmianami). Nadzór nad Fundacją sprawuje Minister Ochrony Środowiska.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.2</h3>
            <p>Fundacja została ustanowiona przez Fundatorów Jolantę Boczkowską i Agnieszkę Kunę, zwane dalej FUNDATOREM.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.3</h3>
            <p>Fundacja ma siedzibę w Warszawie przy ulicy Polskich Skrzydeł 4 m 87. Terenem działania jest obszar RP, jednak dla właściwego realizowania celów, Fundacja może prowadzić działalność poza granicami RP.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.4</h3>
            <p>Fundacja ma charakter charytatywny.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.5</h3>
            <p>Fundacja została powołana na czas nieokreślony.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.6</h3>
            <p>Fundacja może prowadzić zarówno nieodpłatną jak i odpłatną działalność pożytku publicznego, co – bez zarejestrowania się jako przedsiębiorca, tj. bez zarejestrowania działalności gospodarczej – umożliwia, na określonych warunkach, sprzedaż usług i towarów. Przychód z odpłatnej działalności służy wyłącznie prowadzeniu działalności pożytku publicznego.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.7</h3>
            <p>Fundacja nie prowadzi działalności gospodarczej.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.8</h3>
            <p>Fundacja z chwilą wpisania do KRS ma osobowość prawną.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.9</h3>
            <p>Fundacja współpracuje z Głównym Inspektorem Weterynarii, Ministrami: Zdrowia, Edukacji Narodowej, Spraw Wewnętrznych i Administracji i samorządami lokalnymi, policją, strażą miejską.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.10</h3>
            <p>Fundacja może tworzyć oddziały, zakłady i filie.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.11</h3>
            <p>Fundacja może zatrudniać pracowników i współpracować z wolontariuszami.</p>
          </div>
        </div>
      </>
    },
    {
      title: "Rozdział II - Cele i sposoby działania",
      content: <>
        <div className="space-y-6 text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white">
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.1</h3>
            <p>Ogólnym celem działalności Fundacji jest ekologia, ochrona zwierząt udomowionych i dziko żyjących, ochrona dziedzictwa przyrodniczego, mianowicie:</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Wspieranie wszelkich działań mających na celu zapobieganie i zwalczanie bezdomności zwierząt.</li>
              <li>Przeciwdziałanie wszelkim formom stosowania przemocy i okrucieństwa wobec zwierząt.</li>
              <li>Udzielanie pomocy zwierzętom krzywdzonym, porzuconym oraz zagubionym.</li>
              <li>Propagowanie idei ochrony praw zwierząt w społeczeństwie.</li>
              <li>Propagowanie idei odpowiedzialnego gospodarowania odpadami komunalnymi.</li>
              <li>Propagowanie idei troski o środowisko naturalne.</li>
            </ul>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.2</h3>
            <p>Fundacja realizuje swoje cele poprzez:</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Pomoc medyczną oraz realizowanie programu kastracji i sterylizacji zwierząt.</li>
              <li>Wspieranie oraz prowadzenie przytulisk, ośrodków adopcyjnych, domów tymczasowych, schronisk oraz hoteli dla bezdomnych zwierząt.</li>
              <li>Poszukiwanie domów docelowych i tymczasowych dla bezdomny zwierząt.</li>
              <li>Działalność adopcyjną</li>
              <li>Udzielanie wsparcia osobom prywatnym zajmującym się zwierzętami.</li>
              <li>Współpracę i szkolenie wolontariuszy.</li>
              <li>Współpracę z innymi organizacjami wspierającymi ochronę zwierząt oraz schroniskami dla bezdomnych zwierząt.</li>
              <li>Współpracę z instytucjami państwowymi, samorządowymi, sektorem gospodarczym, środkami masowego przekazu, osobami publicznymi, organizacjami pozarządowymi w kraju i za granicą.</li>
              <li>Współdziałanie z właściwymi instytucjami, tj. Policją, Strażą Miejską oraz administracją publiczną w zakresie ujawniania i ścigania przestępstw o wykroczeń wobec zwierząt.</li>
              <li>Współpracę z jednostkami oświatowymi oraz wychowawczymi.</li>
              <li>Organizowanie akcji edukacyjnych i propagandowych, warsztatów, seminariów oraz szkoleń.</li>
              <li>Rozpowszechnianie wiedzy o ochronie praw zwierząt.</li>
              <li>Rozpowszechnianie wiedzy na temat właściwego oznakowywania zwierząt oraz opracowanie i wdrażanie programu identyfikacji zwierząt.</li>
              <li>Występowanie z inicjatywą w zakresie wydawanie lub zmian przepisów legislacyjnych dotyczących praw zwierząt.</li>
              <li>Wydawanie folderów, biuletynów, ulotek, plakatów oraz innych materiałów informacyjnych.</li>
              <li>Prowadzenie punktów informacyjnych Fundacji, również na imprezach masowych.</li>
              <li>Organizowanie aukcji charytatywnych, zbiórek publicznych, aukcji na rzecz bezdomnych i krzywdzonych zwierząt w kraju i za granicą.</li>
              <li>Przyznawanie nagród i wyróżnień osobom fizycznym i prawnym za działalność na rzecz humanitarnego traktowania zwierząt i zapobiegania bezdomności oraz nadawanie tytułu Sponsora Fundacji.</li>
              <li>Prowadzenie i utrzymanie strony internetowej Fundacji.</li>
            </ul>
          </div>
        </div>
      </>
    },
    {
      title: "Rozdział III - Majątek i dochody Fundacji",
      content: <>
        <div className="space-y-6 text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white">
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.1</h3>
            <p>Majątek Fundacji stanowi Fundusz Założycielski, na który składa się wkład pieniężny przekazany przez Fundatora w kwocie 500 PLN</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.2</h3>
            <p>Dochodami Fundacji mogą być:</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Darowizny, dotacje, spadki i zapisy od osób fizycznych, prawnych krajowych i zagranicznych,</li>
              <li>Subwencje osób prawnych,</li>
              <li>Odsetki bankowe i inne dochody kapitałowe,</li>
              <li>Dochody z majątku ruchomego i nieruchomego,</li>
              <li>Dochody ze zbiórek środków finansowych i rzeczowych oraz imprez publicznych.</li>
              <li>Inne wpływy, np. wpływy z reklam zamieszczonych na stronie Fundacji, itp.</li>
            </ul>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.3</h3>
            <p>Całość dochodów uzyskiwanych przez Fundację jest przeznaczana wyłącznie na działalność statutową Fundacji oraz na pokrycie niezbędnych kosztów działalności Fundacji. Fundacja nie ma prawa podejmowania działań polegających na:</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Udzielaniu pożyczek lub zabezpieczaniu zobowiązań majątkiem Fundacji w stosunku do jej organów oraz pracowników Fundacji a także w stosunku do osób, które z osobami tymi pozostają w związku małżeńskim, w stosunku pokrewieństwa lub powinowactwa w linii prostej, w linii bocznej do drugiego stopnia albo są związani z tytułu przysposobienia, opieki lub kurateli, czyli w stosunku do tzw. „osób bliskich".</li>
              <li>Przekazywaniu bądź wykorzystaniu majątku Fundacji na rzecz osób wymienionych w Pkt1, Art3, Rozdział III, jeżeli nie jest to bezpośrednio związane z wykonaniem zadań statutowych Fundacji, w szczególności jeżeli przekazanie to następuje bezpłatnie lub na preferencyjnych warunkach.</li>
              <li>Podejmowaniu innych rozporządzeń środkami Fundacji w sposób dla niej niekorzystny.</li>
            </ul>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.4</h3>
            <p>Fundacja odpowiada za swoje zobowiązania całym swoim majątkiem.</p>
          </div>
        </div>
      </>
    },
    {
      title: "Rozdział IV - Władze Fundacji",
      content: <>
        <div className="space-y-6 text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white">
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.1</h3>
            <p>Władzą Fundacji jest ZARZĄD FUNDACJI zwany dalej ZARZĄDEM.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.2</h3>
            <p>Zarząd Fundacji.</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Członkowie Zarządu Fundacji, w uzasadnionych wypadkach mogą otrzymywać wynagrodzenie za swoją pracę.</li>
              <li>Członkowie Zarządu nie mogą prowadzić lub uczestniczyć w prowadzeniu interesów pozostających w konflikcie z interesami Fundacji.</li>
              <li>Członków Zarządu powołuje Fundator.</li>
              <li>Fundator może wejść w skład Zarządu i pełnić funkcję Prezesa Zarządu.</li>
              <li>Członkowie Zarządu powołani są na czas nieokreślony.</li>
              <li>Zarząd składa się z 1-5 osób w tym Prezesa.</li>
              <li>Skład Zarządu może zostać zmieniony na wspólnym posiedzeniu, Zarządu i Fundatora zwykłą większością głosów.</li>
              <li>Posiedzenia Zarządu zwołuje się w miarę potrzeby, nie rzadziej jednak niż raz na 6 miesięcy (w przypadku małej aktywności Fundacji raz na 12 miesięcy). Posiedzenie zwołuje Prezes Zarządu z własnej inicjatywy lub na żądanie któregoś z członków Zarządu lub Fundatora.</li>
            </ul>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.3</h3>
            <p>Organem kontrolnym dla Zarządu Fundacji jest RADA FUNDACJI zwana dalej RADĄ.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.4</h3>
            <p>Rada Fundacji.</p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li>Członkowie Rady Fundacji wykonują swe zadania nieodpłatnie.</li>
              <li>Członkowie Rady nie mogą prowadzić lub uczestniczyć w prowadzeniu interesów pozostających w konflikcie z interesami Fundacji.</li>
              <li>Członków Rady powołuje Fundator.</li>
              <li>Członkowie Rady powołani są na czas nieokreślony.</li>
              <li>Rada składa się z 2-5 osób w tym Prezesa Rady.</li>
              <li>Skład Rady może zostać zmieniony na wspólnym posiedzeniu Rady i Fundatora zwykłą większością głosów.</li>
              <li>Posiedzenia Rady zwołuje się w miarę potrzeby, nie rzadziej jednak niż raz na 6 miesięcy (w przypadku małej aktywności Fundacji raz na 12 miesięcy). Posiedzenie zwołuje Prezes Rady z własnej inicjatywy lub na żądanie któregoś z członków Rady.</li>
            </ul>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.5</h3>
            <p>Wykluczenia: Członkowie Rady Fundacji nie mogą być jednocześnie członkami Zarządu ani też pozostawać z nimi w stosunku pokrewieństwa, powinowactwa lub podległości służbowej, w związku małżeńskim lub we wspólnym pożyciu.</p>
          </div>
        </div>
      </>
    },
    {
      title: "Rozdział V - Postanowienia końcowe",
      content: <>
        <div className="space-y-6 text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white">
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.1</h3>
            <p>Zmiany w Statucie Fundacji dotyczące modyfikacji lub rozszerzenia celu działania Fundacji oraz zmiany dotyczące nazwy, struktury władz i przekształcenia Fundacji mogą być dokonywane na wniosek Fundatora, członków Zarządu lub Rady Fundacji. Zmiany te dokonywane są w drodze uchwały, którą członkowie Zarządu i Rady podejmują na wspólnym posiedzeniu zwykłą większością głosów, w obecności 2/3 liczby wszystkich członków Władz Fundacji.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.2</h3>
            <p>Dla efektywnego urzeczywistnienia swoich celów, Fundacja może połączyć się z inną fundacją, nie może to jednak zmienić celu Fundacji. Decyzję o połączeniu podejmuje Rada Fundacji poprze jednomyślną uchwałę podjętą na wniosek Zarządu, po zasięgnięciu opinii Fundatorów.</p>
          </div>
          <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
            <h3 className="text-lg font-semibold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-2">Art.3</h3>
            <p>Fundacja ulega likwidacji w razie osiągnięcia celów dla których została powołana lub w razie wyczerpania się jej aktywów finansowych i majątku. Uchwałę o likwidacji Fundacji podejmują na wniosek Prezesa Zarządu członkowie Zarządu i Rady (o ile została powołana) na wspólnym posiedzeniu zwykłą większością głosów, w obecności 2/3 wszystkich członków Władz Fundacji.</p>
            <p className="mt-4">Uchwała o likwidacji określa przeznaczenie środków majątkowych Fundacji pozostałych po jej likwidacji. Środki majątkowe pozostałe po likwidacji Fundacji mogą być przeznaczone na rzecz organizacji działającej na terenie Polski o zbliżonych celach statutowych.</p>
          </div>
        </div>
      </>
    }
  ];

  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <Helmet>
        <title>Statut | Fundacja "Znajdki"</title>
        <meta name="description" content="Statut Fundacji Znajdki. Zapoznaj się z naszymi celami, zasadami działania i strukturą organizacyjną." />
      </Helmet>

      <StatuteHero />

      <LegalEntityDetails className="mb-8" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <TableOfContents 
          chapters={chapters}
          activeChapter={activeChapter}
          onChapterSelect={setActiveChapter}
        />

        {/* Content */}
        <div className="lg:col-span-2 space-y-8">
          {activeChapter === null ? (
            // Show all chapters when no chapter is selected
            chapters.map((chapter, index) => (
              <div key={index} id={`chapter-${index}`} className="scroll-mt-24">
                <h2 className="text-2xl font-bold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-6">
                  {chapter.title}
                </h2>
                {chapter.content}
              </div>
            ))
          ) : (
            // Show only selected chapter
            <div id={`chapter-${activeChapter}`} className="scroll-mt-24">
              <h2 className="text-2xl font-bold text-accessible-gray-900 dark:text-white high-contrast:text-white mb-6">
                {chapters[activeChapter].title}
              </h2>
              {chapters[activeChapter].content}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}